import {RefCallback, useState} from 'react';
import {useOnResize} from './useOnResize';

interface OffsetWidth<T extends HTMLElement> {
  offsetWidth?: number;
  ref: RefCallback<T>;
}

export function useOffsetWidth<T extends HTMLElement = HTMLElement>(): OffsetWidth<T> {
  const [offsetWidth, setOffsetWidth] = useState<number>();
  const {ref} = useOnResize((resized) => setOffsetWidth(resized.offsetWidth));
  return {offsetWidth, ref};
}
